module.exports = __webpack_public_path__ + "img/69.d422a0f2.jpg";